import { ListPayeeRequirementsFilterParameterCreatedAt } from "@wingspanhq/wingspan-api-sdk";

/**
 * `listBatches` takes an inclusive `createdAt` range, so the year the toolbar
 * picks becomes that calendar year's first and last instant.
 */
export const selectorImportBatchesCreatedAtFilter = (
  year?: string
): ListPayeeRequirementsFilterParameterCreatedAt | undefined => {
  const numericYear = Number(year);

  if (!year || !Number.isInteger(numericYear)) {
    return undefined;
  }

  return {
    gte: new Date(numericYear, 0, 1),
    lte: new Date(numericYear, 11, 31, 23, 59, 59, 999)
  };
};
